import type { IEnvConfig } from "@adgm/cross-models";

const apikeyBugsnagBeta = "67a5275aa12dc423bc113ad69da9d93c";
const OSSURL = "https://aspen-beta.oss-ap-southeast-1.aliyuncs.com";
const staticHost = `https://static.beta.test-aspendigital.co`;
const beta: IEnvConfig = {
  env: "beta",
  host: "https://api-ad-beta.test-aspendigital.co/",
  websocket: {
    host: "wss://ws-ad-beta.test-aspendigital.co:8080", // aspen beta
  },
  googlePlayUrl: "https://www.pgyer.com/T8727P5S",
  appStoreUrl: "https://www.pgyer.com/drqX",
  ossUrl: OSSURL, //策略图片oss地址
  appDomain: "https://apponly-ad-beta.test-aspendigital.co/",
  webDomain: "https://portal-ad-beta.test-aspendigital.co",
  domainUriPrefix: "https://beta-adgm.onelink.me/9CqI",
  staticHost,
  // 蒲公英
  fallbackUrl: {
    android: "https://www.pgyer.com/T8727P5S",
    ios: "https://www.pgyer.com/drqX",
  },
  packageName: {
    android: "com.aspendigital.adgm.beta",
    ios: "com.aspendigital.adgm.beta",
  },

  klineChartUrl: "",
  tvChartUrl: "https://tradingview-ad-beta.test-aspendigital.co/",
  apiKeyBugsnag: apikeyBugsnagBeta,
  minimumVersion: {
    android: "",
    ios: "",
  },
  operationServer: "https://api-aoperation-ad-beta.test-aspendigital.co/",
  saasServer: "",
  appScheme: "BetaADGM",
  universalDownloadLink: "https://beta-adgm.onelink.me/9CqI/vw141dv5",
  aiChatUrl: "https://adgm-ai-git-beta-aspendigitallimited.vercel.app/app",
};
export default beta;
